// Deux sons, pas trois : validation d'une étape, et réception d'une livraison
// Honeywell. Avec un interrupteur pour tout couper (§13) — en surface de vente,
// une application qui bipe à chaque interaction devient insupportable.
//
// Synthétisés au WebAudio : aucun fichier à charger, rien à télécharger hors
// ligne, et le son reste identique d'un poste à l'autre.

const CLE = 'flashcp-sons'

export const sonsActifs = (): boolean => localStorage.getItem(CLE) !== 'off'

export function basculerSons(): boolean {
  const actif = !sonsActifs()
  localStorage.setItem(CLE, actif ? 'on' : 'off')
  return actif
}

type Ctor = typeof AudioContext
let ctx: AudioContext | null = null

function contexte(): AudioContext | null {
  const C: Ctor | undefined =
    window.AudioContext ?? (window as unknown as { webkitAudioContext?: Ctor }).webkitAudioContext
  if (!C) return null
  ctx ??= new C()
  return ctx
}

function bip(frequences: number[], dureeMs: number, volume: number): void {
  if (!sonsActifs()) return
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return
  const c = contexte()
  if (!c) return
  if (c.state === 'suspended') void c.resume()

  frequences.forEach((f, i) => {
    const osc = c.createOscillator()
    const gain = c.createGain()
    const t0 = c.currentTime + (i * dureeMs) / 1000
    osc.type = 'sine'
    osc.frequency.setValueAtTime(f, t0)
    gain.gain.setValueAtTime(0, t0)
    gain.gain.linearRampToValueAtTime(volume, t0 + 0.012)
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dureeMs / 1000)
    osc.connect(gain).connect(c.destination)
    osc.start(t0)
    osc.stop(t0 + dureeMs / 1000 + 0.02)
  })
}

/** Étape validée — deux notes montantes, brèves. */
export const sonValidation = () => bip([660, 880], 110, 0.05)

/** Livraison Honeywell reçue — trois notes, la couleur de l'appareil. */
export const sonLivraison = () => bip([523, 659, 784], 95, 0.045)
